import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ADR_REVIEW } from "../../../_constants/actionConstants";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { adrSections } from "../../../_constants/docSections";

export function AdrCorrectionCommentsV3(props) {
  const {
    tabId,
    section,
    userIsReviewer,
    isInReview,
    markAdrDirty,
    reviewerInitials,
    correctionComments,
    genericMetadata: ngm,
  } = props;

  const corrComms = correctionComments || [];
  const adr = useSelector((state) => state.adr.openAdrs[props.tabId] || null);
  const user = useSelector((state) => state.authentication.user || null);
  const dispatch = useDispatch();

  const handleClick_add =
    (section, fieldInfo = {}) =>
    (e) => {
      e.preventDefault();
      if (!user) return;
      if (section === adrSections.ADR_SECTION_NARRATIVE) fieldInfo = ngm || {};
      dispatch({
        type: ADR_REVIEW.CORRECTION_COMMENTS.ADD_BLANK,
        tabId,
        byUserId: user.userId,
        section,
        fieldInfo: {
          ...fieldInfo,
          reviewerInitials,
        },
      });
      markAdrDirty();
    };

  return (
    <div className="d-flex flex-row flex-wrap">
      {corrComms.map((cc) => {
        return (
          <AdrCorrectionCommentRowV3
            key={`corrCommRowKey_${cc.clientId}`}
            tabId={tabId}
            section={section}
            userIsReviewer={userIsReviewer}
            isInReview={isInReview}
            currentUserId={user.userId}
            reviewerInitials={reviewerInitials}
            correctionComment={cc}
            markAdrDirty={markAdrDirty}
          />
        );
      })}
      {userIsReviewer && adr && adr.isInReview && (
        <div className="row w-100 my-2">
          <div className="col-md-12">
            <button
              key={`corrCommAddButtonKey_${section}`}
              name="addReviewComment"
              id="addReviewComment"
              className="btn btn-sm btn-warning"
              onClick={handleClick_add(section)}
              disabled={!userIsReviewer}
            >
              <FontAwesomeIcon icon="comment-dots" className="fa-fw mr-2" />
              Comment
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function AdrCorrectionCommentRowV3({
  userIsReviewer,
  tabId,
  currentUserId,
  correctionComment,
  reviewerInitials,
  isInReview,
  markAdrDirty,
}) {
  const [comments, setComments] = useState("");
  useEffect(() => setComments(correctionComment.comments), [correctionComment.comments]);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setComments(e.target.value);
    markAdrDirty();
  };

  const handleBlur = (e) =>
    dispatch({
      type: ADR_REVIEW.CORRECTION_COMMENTS.UPDATE,
      tabId,
      clientId: correctionComment.clientId,
      ccFields: { comments },
    });

  const handleClick_delete = (e) => {
    e.preventDefault();
    if (isInReview && userIsReviewer) {
      dispatch({
        type: ADR_REVIEW.CORRECTION_COMMENTS.DELETE,
        tabId,
        clientId: correctionComment.clientId,
      });
      markAdrDirty();
    }
  };

  const handleClick_comment = (e) => {
    e.preventDefault();
    if (isInReview && userIsReviewer && currentUserId === correctionComment.byUserId) {
      dispatch({
        type: ADR_REVIEW.CORRECTION_COMMENTS.UPDATE,
        tabId,
        clientId: correctionComment.clientId,
        ccFields: { isNew: !correctionComment.isNew },
      });
      markAdrDirty();
    }
  };

  const hasFieldInfoLabel = () =>
    correctionComment.fieldInfo && correctionComment.fieldInfo.label;

  return (
    <div className="card w-100 my-2 mr-2 corr-comm-card">
      <div className="card-body p-1 bg-lightyellow">
        <div className="d-flex flex-row justify-content-between">
          <div style={{ fontSize: "0.9rem" }} className="text-muted my-auto">
            <em>{`Correction comments${hasFieldInfoLabel() ? " on..." : ":"}`}</em>
          </div>
          {isInReview && userIsReviewer && (
            <div>
              <button
                id={`corrCommDelete_${correctionComment.clientId}`}
                name="delete"
                className="btn btn-sm"
                onClick={handleClick_delete}
              >
                <FontAwesomeIcon icon="times" className="fa-sm" />
              </button>
            </div>
          )}
        </div>
        {hasFieldInfoLabel() && (
          <div className="d-flex flex-row text-small">
            <span>
              <b>{`${correctionComment.fieldInfo.label}: `}</b>
              {correctionComment.fieldInfo.subLabel}
            </span>
          </div>
        )}
        {correctionComment.isNew ? (
          <>
            <textarea
              name="correctionComment"
              id={`correctionComment_${correctionComment.clientId}`}
              className="form-control"
              rows="3"
              disabled={!userIsReviewer}
              value={comments}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <small>
              {`-${reviewerInitials || "(N/A)"}, ${moment(
                correctionComment.commentDate
              ).format("MM/DD/YYYY h:mm a")}`}
            </small>
          </>
        ) : (
          <>
            <hr className="my-1" />
            <div className="mb-0">
              <button
                id={`correctionComment_${correctionComment.clientId}`}
                name="comments"
                className="btn btn-outline-dark text-left w-100 p-1"
                onClick={handleClick_comment}
              >
                {correctionComment.comments || "(No Comment)"}
              </button>
              <br />
              <small>
                {`-${
                  ("fieldInfo" in correctionComment &&
                    correctionComment.fieldInfo &&
                    correctionComment.fieldInfo.reviewerInitials) ||
                  "(N/A)"
                }, ${moment(correctionComment.commentDate).format("MM/DD/YYYY h:mm a")}`}
              </small>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
